export const checklisten = {
  dummy: {
    imageUrl: '/assets/images/checklisten/checkliste_dummy.jpg',
    pages: 2
  },
  1: {
    imageUrl: '/assets/images/checklisten/checkliste_1.jpg',
    pages: 2
  },
  2: {
    imageUrl: '/assets/images/checklisten/checkliste_2.jpg',
    pages: 3
  },
  3: {
    imageUrl: '/assets/images/checklisten/checkliste_3.jpg',
    pages: 2
  },
  4: {
    imageUrl: '/assets/images/checklisten/checkliste_4.jpg',
    pages: 3
  },
  5: {
    imageUrl: '/assets/images/checklisten/checkliste_5.jpg',
    pages: 3
  },
  6: {
    imageUrl: '/assets/images/checklisten/checkliste_6.jpg',
    pages: 2
  },
  7: {
    imageUrl: '/assets/images/checklisten/checkliste_7.jpg',
    pages: 2
  },
  8: {
    imageUrl: '/assets/images/checklisten/checkliste_8.jpg',
    pages: 2
  },
  9: {
    imageUrl: '/assets/images/checklisten/checkliste_9.jpg',
    pages: 2
  },
  10: {
    imageUrl: '/assets/images/checklisten/checkliste_10.jpg',
    pages: 2
  },
  14: {
    imageUrl: '/assets/images/checklisten/checkliste_14.jpg',
    pages: 2
  },
  15: {
    imageUrl: '/assets/images/checklisten/checkliste_15.jpg',
    pages: 2
  },
  16: {
    imageUrl: '/assets/images/checklisten/checkliste_16.jpg',
    pages: 2
  },
  17: {
    imageUrl: '/assets/images/checklisten/checkliste_17.jpg',
    pages: 2
  },
  18: {
    imageUrl: '/assets/images/checklisten/checkliste_18.jpg',
    pages: 2
  },
  19: {
    imageUrl: '/assets/images/checklisten/checkliste_19.jpg',
    pages: 2
  },
  20: {
    imageUrl: '/assets/images/checklisten/checkliste_20.jpg',
    pages: 2
  },
  21: {
    imageUrl: '/assets/images/checklisten/checkliste_21.jpg',
    pages: 2
  },
  22: {
    imageUrl: '/assets/images/checklisten/checkliste_22.jpg',
    pages: 2
  },
  23: {
    imageUrl: '/assets/images/checklisten/checkliste_23.jpg',
    pages: 2
  },
  25: {
    imageUrl: '/assets/images/checklisten/checkliste_25.jpg',
    pages: 2
  },
  26: {
    imageUrl: '/assets/images/checklisten/checkliste_26.jpg',
    pages: 2
  },
  27: {
    imageUrl: '/assets/images/checklisten/checkliste_27.jpg',
    pages: 2
  },
  28: {
    imageUrl: '/assets/images/checklisten/checkliste_28.jpg',
    pages: 2
  },
  29: {
    imageUrl: '/assets/images/checklisten/checkliste_29.jpg',
    pages: 3
  },
  30: {
    imageUrl: '/assets/images/checklisten/checkliste_30.jpg',
    pages: 2
  },
};
